export interface AnswerObject {
  text: string;
}

export interface Question {
  question: string;
  answers: Array<string | AnswerObject>;  // Allow both string and AnswerObject
  correctAnswer: string;
  explanation?: string;
  bloomsLevel?: string;
  standardReference?: string;
  answerType?: string;
}

// Add type guard function
export function isAnswerObject(answer: string | AnswerObject): answer is AnswerObject {
  return typeof answer === 'object' && answer !== null && 'text' in answer;
}

export interface Standard {
  _id: string;
  code: string;
  standard: string;
  description: string;
  strand?: string;
  gradeLevel?: string;
  short_description?: string;
  teachingStandard?: string;
}

export interface PassageIllustration {
  imageUrl: string;
  imagePrompt: string;
  placementIndex?: number;
  imageGenerated: boolean;
  altText: string;
  revisedPrompt?: string;
  alignment: 'left' | 'right' | 'center' | 'full-width';
  visualSize: number; // 50-150
}

export interface PassageData {
  title: string;
  passage: string;
  genre: string;
  questions: Question[];
  gradeLevel: string;
  illustrations?: PassageIllustration[];
}

export interface AssessmentResponse {
  passages: PassageData[];
  combinedQuestions?: Question[];
  answerKey?: string;
  isPairedPassage: boolean;
  _id?: string; // Database ID for tracking saved assessments
}

export interface PassageRequest {
  topic: string;
  genre: string;
}

export interface AssessmentRequestData {
  isPairedPassage: boolean;
  generateQuestions: boolean;
  questionStyle: string;
  includeAnswerKey: boolean;
  questionMix?: string; // 'multiple_choice', 'mixed', 'text_only'
  passages?: PassageRequest[];
  topic?: string;
  genre?: string;
  gradeLevel?: string;
  paragraphCount?: number;
  revisingAndEditing?: boolean;
  standards: Array<{
    id: string;
    code: string;
    standard: string;
    description: string;
  } | null>;
  modificationPrompt?: string;
  currentContent?: string;
  currentQuestions?: Question[];
  language?: string;
  generateImages?: boolean;
  imageCount?: number;
}
